import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'
import Vue from 'vue'

var module = {
  endpoint: 'size',
  getNew: {
    deleted: false,
    name: null,
    catalogs: []
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'sizeType.name',
        title: 'tipo taglia',
        sortField: 'sizeType.name'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
  async getSizesByType (type) {
    let url = `${this.endpoint}/type/${type}`
    console.log('@@@@@url', url)
    let sizes = (await Vue.http.get(url)).body
    return sizes
  },
  async getSizeTypes () {
    let url = `${this.endpoint}/type`
    console.log('@@@@url', url)
    let sizeTypes = (await Vue.http.get(url)).body
    return sizeTypes
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/sizes.js